const AppName = 'Pdp'

export default AppName
